import { ContainerModule } from 'inversify';
import { LayoutService, LayoutServiceSymbol } from './layout-service';

export const layoutModule = new ContainerModule((bind) => {
  bind<LayoutService>(LayoutServiceSymbol).to(LayoutService).inSingletonScope();
});
